module.exports = __webpack_public_path__ + "img/pkw_freigaben.fe8cf607.png";